import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaiairportcabservice() {



  const cardData = {




keyword: "Mumbai Airport Cab Service",

headingDescription: "Garud Cab Service provides comfortable and reliable Mumbai Airport Cab Service for business travelers, families, tourists, senior citizens, students, and groups looking for convenient airport transportation. Customers can book chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, Tempo Traveller, and other suitable vehicles for airport pickup and drop, hotel transfers, corporate travel, railway station transfers, city travel, intercity journeys, and customized travel plans. With experienced drivers, clean and well-maintained vehicles, comfortable seating, spacious luggage areas, flight schedule coordination, flexible pickup locations, transparent pricing, and 24/7 customer assistance, Garud Cab Service makes Mumbai Airport travel smooth and convenient. Travelers can arrange direct transportation to business districts, residential areas, hotels, railway stations, tourist attractions, and nearby destinations around Mumbai according to their preferred schedule.",

topPlaces: [
  {
    title: "Bandra",
    description: "Bandra is a prominent Mumbai locality known for corporate offices, shopping areas, hotels, restaurants, entertainment venues, and popular residential neighborhoods. Travelers arriving at Mumbai Airport can conveniently reach Bandra through a private chauffeur-driven cab. Garud Cab Service offers suitable vehicles with comfortable seating and luggage space for individual passengers, families, and business travelers."
  },
  {
    title: "Andheri",
    description: "Andheri is one of Mumbai's busiest commercial and residential areas and provides convenient access to the airport, business districts, hotels, and major transportation routes. Airport passengers frequently require direct transfers to offices, homes, and hotels in Andheri. Customers can book a reliable cab with flexible pickup arrangements and professional chauffeur assistance."
  },
  {
    title: "Powai",
    description: "Powai is a well-developed Mumbai neighborhood known for business parks, technology companies, residential communities, educational institutions, and Powai Lake. Travelers arriving at Mumbai Airport can reach Powai comfortably without changing vehicles. Garud Cab Service provides private airport transfers with suitable cars and spacious luggage areas."
  },
  {
    title: "BKC",
    description: "Bandra Kurla Complex is one of Mumbai's leading commercial and corporate districts and attracts professionals traveling for meetings, conferences, and business activities. Customers arriving at Mumbai Airport can book a direct cab to offices, hotels, and event venues in BKC. Garud Cab Service offers comfortable vehicles with flexible airport pickup and drop services."
  },
  {
    title: "Colaba",
    description: "Colaba is a popular South Mumbai destination known for heritage buildings, shopping streets, hotels, restaurants, and major attractions. Tourists and business travelers arriving at Mumbai Airport can use a private cab for direct transportation to Colaba. Customers can also customize their journey to include nearby sightseeing destinations around South Mumbai."
  },
  {
    title: "Juhu",
    description: "Juhu is a popular Mumbai locality known for its beach, hotels, restaurants, entertainment venues, and residential areas. Travelers arriving at the airport often choose private cab transportation for convenient door-to-door travel. Garud Cab Service provides comfortable vehicles for families, couples, tourists, and corporate passengers traveling to Juhu."
  },
  {
    title: "Lower Parel",
    description: "Lower Parel is an important commercial and lifestyle district of Mumbai featuring corporate offices, shopping centers, hotels, restaurants, and business establishments. Airport passengers can conveniently travel directly to Lower Parel by chauffeur-driven cab. Customers can select a suitable vehicle based on their passenger count, luggage, and travel requirements."
  },
  {
    title: "Dadar",
    description: "Dadar is a major central Mumbai locality and an important transportation hub with railway connectivity, shopping markets, residential areas, and commercial establishments. Travelers arriving at Mumbai Airport can arrange direct cab transportation to Dadar for onward travel or local requirements. Garud Cab Service provides flexible airport transfers with professional drivers."
  },
  {
    title: "Thane",
    description: "Thane is a major city in the Mumbai Metropolitan Region and is known for residential communities, commercial centers, business parks, and educational institutions. Travelers arriving at Mumbai Airport can book a private cab for direct transportation to Thane without multiple changes. Customers can choose Sedan, SUV, Ertiga, Innova, or Innova Crysta according to their requirements."
  },
  {
    title: "Navi Mumbai",
    description: "Navi Mumbai is a planned urban region with major commercial, residential, educational, and industrial areas. Passengers arriving at Mumbai Airport may require comfortable long-distance airport transfers to locations such as Vashi, Nerul, Belapur, and surrounding areas. Garud Cab Service provides private chauffeur-driven vehicles with flexible airport pickup and drop arrangements."
  }
],





"services": [
{
"name": "Mumbai Airport Car Rental",
"description": "Book Mumbai Airport Car Rental for convenient private transportation from Mumbai Airport to your preferred destination. Comfortable AC cars with professional chauffeurs can be arranged for airport transfers, business travel, family journeys, tourism, and scheduled city or outstation trips."
},
{
"name": "Airport Taxi Mumbai",
"description": "Choose Airport Taxi Mumbai for reliable transportation to and from Mumbai Airport with convenient pickup and drop arrangements. Sedan, SUV, Innova, and premium taxi options can be selected according to passenger count, luggage, destination, and travel requirements."
},
{
"name": "Mumbai Airport Transfer",
"description": "Book Mumbai Airport Transfer for comfortable point-to-point transportation between Mumbai Airport and your preferred location. The service is suitable for arriving passengers, departing travelers, corporate executives, families, tourists, and individuals requiring scheduled airport connectivity."
},
{
"name": "Mumbai Airport Taxi",
"description": "Reserve Mumbai Airport Taxi for convenient airport pickup and drop service with professional chauffeurs and well-maintained AC vehicles. The service can be arranged for Mumbai city destinations as well as nearby intercity and outstation locations."
},
{
"name": "Airport Transfer Mumbai",
"description": "Choose Airport Transfer Mumbai for private transportation between Mumbai Airport and hotels, business locations, residential areas, railway stations, or outstation destinations. Suitable vehicle categories can be arranged according to passengers, luggage, and journey requirements."
},
{
"name": "Mumbai Airport Taxi Booking",
"description": "Book Mumbai Airport Taxi Booking in advance for a convenient and scheduled airport transfer. Customers can select suitable vehicle options and arrange pickup according to their flight timing, terminal, passenger count, luggage requirements, and destination."
},
{
"name": "Mumbai to Shirdi Taxi Service",
"description": "Choose Mumbai to Shirdi Taxi Service for comfortable private transportation to Shirdi with professional chauffeur assistance. The service is suitable for devotees, families, senior passengers, tourists, and travelers planning a convenient pilgrimage journey from Mumbai."
},
{
"name": "Car Hire Mumbai Airport",
"description": "Book Car Hire Mumbai Airport for chauffeur-driven transportation from the airport to your preferred destination. Sedan, SUV, Innova, and premium vehicles can be arranged for airport transfers, corporate travel, family trips, sightseeing, and outstation journeys."
},
{
"name": "Airport Cabs Mumbai",
"description": "Choose Airport Cabs Mumbai for convenient private transportation to or from Mumbai Airport. Comfortable AC vehicles and professional drivers can be arranged for passengers traveling to Mumbai city, business locations, hotels, or nearby outstation destinations."
},
{
"name": "Cab from Pune to Mumbai Airport",
"description": "Book Cab from Pune to Mumbai Airport for direct and comfortable airport transportation from Pune. The service is suitable for individuals, families, corporate travelers, and passengers planning domestic or international flights from Mumbai Airport."
},
{
"name": "Mumbai to Shirdi Cab Service",
"description": "Reserve Mumbai to Shirdi Cab Service for a comfortable and convenient pilgrimage journey with private chauffeur-driven transportation. Suitable cars can be arranged for families, devotees, senior citizens, small groups, and passengers carrying luggage."
},
{
"name": "Mumbai Airport to Shirdi Taxi",
"description": "Book Mumbai Airport to Shirdi Taxi for direct transportation from Mumbai Airport to Shirdi. The service is suitable for passengers arriving by flight and continuing their journey to Sai Baba Temple with convenient private cab transportation."
},
{
"name": "Mumbai Airport Taxi Service",
"description": "Choose Mumbai Airport Taxi Service for comfortable airport pickup and drop transportation with professional chauffeur assistance. The service is suitable for business travelers, families, tourists, airport passengers, and individuals requiring private transportation."
},
{
"name": "Airport Transfer Mumbai International",
"description": "Book Airport Transfer Mumbai International for convenient transportation from Mumbai International Airport to your preferred destination. The service provides private chauffeur-driven travel suitable for international passengers, families, executives, tourists, and groups."
},
{
"name": "Mumbai Airport Terminal 1 Cab",
"description": "Reserve Mumbai Airport Terminal 1 Cab for convenient pickup or drop transportation at Terminal 1. Comfortable AC vehicles can be arranged according to flight timing, passenger requirements, luggage, and destination for a smooth airport transfer."
},
{
"name": "Mumbai Airport Terminal 2 Cab",
"description": "Book Mumbai Airport Terminal 2 Cab for private transportation to or from Terminal 2 with convenient pickup arrangements. The service is suitable for domestic and international passengers, corporate travelers, families, and tourists requiring direct airport connectivity."
},
{
"name": "Mumbai Airport T1 Taxi Service",
"description": "Choose Mumbai Airport T1 Taxi Service for comfortable airport transportation from Terminal 1 to Mumbai city or nearby destinations. Sedan, SUV, and larger vehicle options can be arranged according to passenger count and luggage requirements."
},
{
"name": "Mumbai Airport T2 Taxi Service",
"description": "Book Mumbai Airport T2 Taxi Service for convenient pickup and drop transportation at Terminal 2. Professional chauffeurs and well-maintained vehicles provide private travel suitable for airport passengers, families, corporate travelers, and tourists."
},
{
"name": "Mumbai Domestic Airport Cab",
"description": "Choose Mumbai Domestic Airport Cab for convenient transportation to and from Mumbai's domestic airport terminal. The service is suitable for passengers traveling for business, family visits, tourism, and personal requirements with flexible vehicle options."
},
{
"name": "Mumbai International Airport Cab",
"description": "Book Mumbai International Airport Cab for comfortable private transportation between Mumbai International Airport and your preferred destination. Professional chauffeur-driven vehicles can be arranged for international passengers, families, executives, tourists, and groups."
},
{
"name": "Mumbai Airport Innova Cab",
"description": "Choose Mumbai Airport Innova Cab for spacious airport transportation suitable for families and small groups. The vehicle provides practical seating and luggage capacity for passengers traveling to or from Mumbai Airport for city and outstation journeys."
},
{
"name": "Mumbai Airport Ertiga Cab",
"description": "Book Mumbai Airport Ertiga Cab for comfortable airport transportation with practical seating and luggage space. It is suitable for families, small groups, corporate passengers, and travelers looking for a spacious vehicle for airport pickup or drop."
},
{
"name": "Mumbai Airport Sedan Taxi",
"description": "Choose Mumbai Airport Sedan Taxi for comfortable AC transportation suitable for individuals, couples, and small families. Sedan vehicles provide practical seating and luggage space for airport transfers, business trips, hotel transfers, and personal journeys."
},
{
"name": "Mumbai Airport SUV Cab",
"description": "Book Mumbai Airport SUV Cab for spacious and comfortable transportation with additional seating and luggage capacity. The service is suitable for families, groups, corporate passengers, tourists, and travelers requiring a larger vehicle for airport transfers."
},
{
"name": "Mumbai Airport AC Cab",
"description": "Choose Mumbai Airport AC Cab for comfortable climate-controlled transportation to or from Mumbai Airport. The service is suitable for families, business travelers, tourists, and individuals who prefer private airport travel with professional chauffeur assistance."
},
{
"name": "Mumbai Airport Luxury Cab",
"description": "Book Mumbai Airport Luxury Cab for premium and comfortable airport transportation with professionally driven vehicles. The service is suitable for executives, corporate passengers, special occasions, business travel, and travelers seeking an enhanced airport transfer experience."
},
{
"name": "Mumbai Airport to Pune Cab",
"description": "Choose Mumbai Airport to Pune Cab for direct and comfortable intercity transportation from Mumbai Airport to Pune. The service is suitable for airport passengers, families, business travelers, tourists, and individuals requiring a private one-way transfer."
},
{
"name": "Mumbai Airport to Nashik Taxi",
"description": "Book Mumbai Airport to Nashik Taxi for convenient private transportation from Mumbai Airport to Nashik. The service is suitable for families, business travelers, tourists, pilgrimage travelers, and passengers looking for comfortable chauffeur-driven intercity travel."
},
{
"name": "Mumbai Airport to Lonavala Cab",
"description": "Choose Mumbai Airport to Lonavala Cab for comfortable private transportation from Mumbai Airport to Lonavala. The service is suitable for families, couples, tourists, weekend travelers, and passengers planning a convenient transfer to the hill station."
},
{
"name": "Mumbai Airport to Shirdi Taxi",
"description": "Book Mumbai Airport to Shirdi Taxi for direct and comfortable transportation from Mumbai Airport to Shirdi. The service is suitable for devotees, families, senior passengers, tourists, and travelers planning a pilgrimage visit to the Sai Baba temple."
},
{
"name": "Mumbai Airport to Goa Cab",
"description": "Choose Mumbai Airport to Goa Cab for long-distance private transportation from Mumbai Airport to Goa. Comfortable AC vehicles with professional chauffeurs can be arranged for families, tourists, corporate travelers, couples, and passengers planning an intercity road journey."
}
],
"tableData": [
["Mumbai Airport Car Rental", "Airport Taxi Mumbai"],
["Mumbai Airport Transfer", "Mumbai Airport Taxi"],
["Airport Transfer Mumbai", "Mumbai Airport Taxi Booking"],
["Mumbai to Shirdi Taxi Service", "Car Hire Mumbai Airport"],
["Airport Cabs Mumbai", "Cab from Pune to Mumbai Airport"],
["Mumbai to Shirdi Cab Service", "Mumbai Airport to Shirdi Taxi"],
["Mumbai Airport Taxi Service", "Airport Transfer Mumbai International"],
["Mumbai Airport Terminal 1 Cab", "Mumbai Airport Terminal 2 Cab"],
["Mumbai Airport T1 Taxi Service", "Mumbai Airport T2 Taxi Service"],
["Mumbai Domestic Airport Cab", "Mumbai International Airport Cab"],
["Mumbai Airport Innova Cab", "Mumbai Airport Ertiga Cab"],
["Mumbai Airport Sedan Taxi", "Mumbai Airport SUV Cab"],
["Mumbai Airport AC Cab", "Mumbai Airport Luxury Cab"],
["Mumbai Airport to Pune Cab", "Mumbai Airport to Nashik Taxi"],
["Mumbai Airport to Lonavala Cab", "Mumbai Airport to Shirdi Taxi"],
["Mumbai Airport to Goa Cab", "Mumbai Airport to Pune Cab"]
],



whychoose: [
  {
    WhyChooseheading: "Mumbai Airport Cab Service for Reliable Airport Transfers",
    WhyChoosedescription: "A private airport cab provides convenient transportation for passengers arriving at or departing from Mumbai Airport, with travel arrangements suited to families, professionals, tourists, students, and groups."
  },
  {
    WhyChooseheading: "Airport Pickup for Arriving Passengers",
    WhyChoosedescription: "Travellers arriving at Mumbai Airport can arrange a direct pickup and continue to their preferred hotel, home, office, railway station, or other accessible destination without changing vehicles."
  },
  {
    WhyChooseheading: "Airport Drop for Departing Flights",
    WhyChoosedescription: "Passengers can arrange transportation from Mumbai, nearby areas, or other preferred pickup points to the airport when they need a convenient ride for a domestic or international flight."
  },
  {
    WhyChooseheading: "Convenient for Business Travellers",
    WhyChoosedescription: "Corporate passengers travelling for meetings, conferences, client visits, office assignments, or business events can use private airport transportation according to their planned schedule."
  },
  {
    WhyChooseheading: "Comfortable Travel for Families & Groups",
    WhyChoosedescription: "Families and groups can select a suitable vehicle according to passenger numbers and luggage requirements, making airport transportation easier when travelling together."
  },
  {
    WhyChooseheading: "Useful for Domestic & International Flights",
    WhyChoosedescription: "Private cab arrangements can be made for passengers travelling on domestic or international flights, with pickup or drop details planned according to their airport travel requirements."
  },
  {
    WhyChooseheading: "Luggage-Friendly Point-to-Point Travel",
    WhyChoosedescription: "Travellers carrying suitcases, bags, or other permitted luggage can choose a vehicle based on their passenger and luggage requirements for a convenient airport transfer."
  },
  {
    WhyChooseheading: "Easy Booking with Garud Cab Service",
    WhyChoosedescription: "Provide your airport pickup or drop location, travel date, flight details when applicable, passenger count, luggage information, and preferred vehicle with Garud Cab Service for booking assistance."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Mumbai Airport Cab Service?",
    answer: "Yes, Garud Cab Service provides private Mumbai Airport cab services for airport pickups, airport drops, business travellers, families, tourists, students, couples, and groups."
  },
  {
    question: "Can I book a Mumbai Airport pickup cab?",
    answer: "Yes, passengers arriving at Mumbai Airport can arrange a private cab for direct transportation to their preferred hotel, home, office, railway station, or other accessible destination."
  },
  {
    question: "Can I book a cab to Mumbai Airport for my flight?",
    answer: "Yes, private airport drop services can be arranged from Mumbai and other preferred pickup locations according to your planned flight schedule."
  },
  {
    question: "Is Mumbai Airport Cab Service available for families?",
    answer: "Yes, families and groups can select a suitable vehicle based on passenger count, luggage quantity, and comfort requirements."
  },
  {
    question: "Can business travellers book Mumbai Airport cabs?",
    answer: "Yes, corporate travellers can use private airport transportation for meetings, conferences, client visits, office assignments, and other professional requirements."
  },
  {
    question: "Can I book a cab for an international flight?",
    answer: "Yes, private airport transportation can be arranged for passengers travelling on international flights as well as domestic flights."
  },
  {
    question: "Can I carry luggage in the Mumbai Airport cab?",
    answer: "Yes, passengers can carry luggage according to the available capacity of the selected vehicle. Larger luggage requirements should be communicated during booking."
  },
  {
    question: "Can I provide my flight details while booking?",
    answer: "Yes, providing your flight details can help communicate the expected airport arrival or departure schedule and assist with planning the transfer."
  },
  {
    question: "Can I book a larger vehicle for airport travel?",
    answer: "Yes, you can request a vehicle according to the number of passengers and luggage requirements so the airport transfer is appropriately planned."
  },
  {
    question: "How can I book a Mumbai Airport Cab Service?",
    answer: "Share your airport pickup or drop location, travel date, flight details when applicable, passenger details, luggage requirements, and preferred vehicle with Garud Cab Service."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Joshi",
    feedback: "I needed a cab for an early airport transfer and arranged a private vehicle in advance. The direct pickup made the journey to Mumbai Airport convenient and easy to plan.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priyanka Shah",
    feedback: "Our family used a private cab after arriving at Mumbai Airport with luggage. The direct drop to our destination made the airport journey comfortable for everyone.",
    rating: 5
  }
];










  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Airport Cab Service",
  "image": "https://garudcabs.com/assets/images/mumbai-airport-cab-service.webp",
  "description": "Book Mumbai Airport Cab Service with Garud Cab for safe, comfortable, and reliable airport transportation. Get Mumbai airport taxi, airport transfer, and car rental services for pickup and drop across Mumbai and nearby destinations. Choose Sedan, Ertiga, SUV, Innova, and Innova Crysta vehicles for business travel, family trips, hotel transfers, and outstation journeys with convenient booking options.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/mumbai-airport-cab-service"
  }
};


  return (
    <div>


<Helmet>
  <title>Mumbai Airport Cab Service | Airport Taxi & Transfer | +91 9970007784</title>

  <meta
    name="description"
    content="Book Mumbai Airport Cab Service with Garud Cab for reliable airport pickup, drop, taxi, transfer, and car rental services. Choose comfortable Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs for Mumbai airport travel."
  />

  <meta
    name="keywords"
    content="Mumbai Airport Car Rental, Airport Taxi Mumbai, Mumbai Airport Transfer, Mumbai Airport Taxi, Airport Transfer Mumbai, Mumbai Airport Cab Service, Mumbai Airport Cab Booking, Mumbai Airport Pickup Cab, Mumbai Airport Drop Taxi, Mumbai Airport Car Rental Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/95.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaiairportcabservice;